import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import Errors from '../../../shared/validation/errors';
import headersBuilder, { Method } from '../../../utils/request';
import { IParametersToCheck, IParametersToFix } from '../../../types/maintenanceTypes';
import setLoadingStatus from '../setLoadingStatus';

export const FETCH_ACCOUNT_PARAMETERS = 'FETCH_ACCOUNT_PARAMETERS';

export type AccountParametersAction = {
  type: string;
  parametersAccounts: IParametersToCheck | IParametersToFix;
};

const fetchAccountsParameters = (parametersAccounts: IParametersToCheck | IParametersToFix): AccountParametersAction => {
  return {
    type: FETCH_ACCOUNT_PARAMETERS,
    parametersAccounts
  };
};

const fetchAccountsParametersAsync = (
  api: string,
  request: IParametersToCheck | IParametersToFix,
  parameter: string,
  account: string
) => {
  return (dispatch: Dispatch): void => {
    dispatch(setLoadingStatus(true));
    fetch(`${api}/maintenance/${parameter}/${account}`, headersBuilder(Method.POST, request))
      .then((response: Response) => Errors.checkResponseForErrors(response, api))
      .then((parametersAccounts: any) => {
        dispatch(fetchAccountsParameters(parametersAccounts));
        toast.success('Load Orders successfully!', {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      })
      .catch((error: Error) => Errors.throwErrorMessage(error))
      .finally(() => dispatch(setLoadingStatus(false)));
  };
};

export default fetchAccountsParametersAsync;
